export function setConfig(obj) {
	localStorage.setItem('environment',JSON.stringify(obj));
}

export function getConfig() {
	const envStr = localStorage.getItem('environment');
	return envStr ?JSON.parse(envStr): null;
}
